import { Component } from '@angular/core';

@Component({
  selector: 'app-all-services',
  templateUrl: './all-services.component.html',
  styleUrl: './all-services.component.scss',
})
export class AllServicesComponent {
  services = [
    {
      title: 'إرسال مستندات لإتمام الخدمات',
      icon: 'fa-solid fa-clipboard-list',
      route: '/send-docs',
    },
    {
      title: 'المسئولية المجتمعية للشركات/الاستدامة',
      icon: 'fa-solid fa-hand-holding-heart',
      route: '/csr',
    },
    {
      title: 'فحص الهياكل المالية',
      icon: 'fa-solid fa-magnifying-glass-dollar',
      route: '/financial-check',
    },
    {
      title: 'الرخصة الذهبية',
      icon: 'fa-regular fa-id-card',
      route: '/goldenPermission',
    },
    {
      title: 'خدمات اعتماد وكلاء المستثمرين',
      icon: 'fa-solid fa-user-tie',
      route: '/agent-accreditation',
    },
    {
      title: 'صحيفة الاستثمار الالكترونية',
      icon: 'fa-solid fa-file-invoice',
      route: '/investment-journal',
    },
    {
      title: 'تراخيص الاستثمار',
      icon: 'fa-solid fa-certificate',
      route: '/investment-licenses',
    },
    {
      title: 'خدمة عدم الالتباس',
      icon: 'fa-solid fa-users-viewfinder',
      route: '/non-confusion',
    },
    {
      title: 'خدمات تأسيس الشركات',
      icon: 'fa-solid fa-building-circle-check',
      route: '/setElectronics',
    },
    {
      title: 'خدمات الجمعيات',
      icon: 'fa-solid fa-landmark',
      route: '/associations',
    },
    {
      title: 'خدمات تعديلات الشركات',
      icon: 'fa-solid fa-screwdriver-wrench',
      route: '/company-modifications',
    },
    {
      title: 'تقارير الاستثمار الأجنبي المباشر',
      icon: 'fa-solid fa-chart-line',
      route: '/investmentReport',
    },
  ];
}
